import { render, staticRenderFns } from "./PageLogin.vue?vue&type=template&id=48e938f1&scoped=true"
import script from "./PageLogin.vue?vue&type=script&lang=js"
export * from "./PageLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e938f1",
  null
  
)

export default component.exports